import { render, staticRenderFns } from "./BaseSearchBar.vue?vue&type=template&id=466093ae&"
import script from "./BaseSearchBar.vue?vue&type=script&lang=ts&"
export * from "./BaseSearchBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSearchBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports